import React from "react";
import Banner from "./sections/PageBanner";
import PageHeader from "./sections/PageHeader";
import Footer from "./sections/PageFooter";

const features = [
  {
    title: "A. Case Tracking and Management",
    description:
      "WITS integrates robust case tracking to ensure transparency and accountability in wildlife crime investigations and prosecutions.",
    points: [
      "Centralized Database: Searchable case info with status, court details, and timelines.",
      "Timeline Monitoring: Visual tracking of delays and missed hearings.",
      "Judgment Outcomes: Detailed logging of sentencing, acquittals, and plea deals.",
      "Cross-Border Linkages: Identify aliases, shared suspects, and financial trails.",
      "Whistleblower Integration: Secure tip reporting linked to ongoing cases.",
      "Evidence & Court Monitoring: Connects with forensic data and courtroom performance logs.",
      "Dashboards & Analytics: Agency performance and heatmaps of case flows.",
    ],
    imageUrl: "/images/penguin.jpg",
    imageAlt: "Fingerprint analysis representing case tracking",
  },
  {
    title: "B. Analytics and Reporting",
    description:
      "WITS transforms raw data into insights that guide policy, enforcement, and conservation strategies.",
    points: [
      "Crime Pattern Analysis: Identify hotspots, seasonal spikes, and commodity trends.",
      "Modus Operandi Analysis: Reveal smuggling methods, syndicate behavior, and actor profiling.",
      "Judicial Performance: Track sentencing trends, conviction rates, and trial delays.",
      "Network Mapping: Visualize cross-border criminal networks and trafficking routes.",
      "Dashboards: Live stats, species impact, and report generation for stakeholders.",
      "Policy Feedback Loop: Flag legal gaps and support reform recommendations.",
    ],
    imageUrl: "/images/leopard.jpg",
    imageAlt: "Data analytics dashboard",
  },
  {
    title: "C. Geographical Mapping",
    description:
      "Mapping tools in WITS provide location-based intelligence to detect crime patterns and optimize responses.",
    points: [
      "Interactive Heatmaps: Real-time views of crime locations and trends.",
      "Case Geo-Tagging: Track every point in a case from arrest to court.",
      "Transnational Routes: Show trafficking paths and high-risk hubs.",
      "Layered Data: Overlay with parks, deforestation, and migration routes.",
      "Live Surveillance: Integrate drones, patrols, and alerts.",
      "Investigative Support: Identify corruption hotspots and plan field ops.",
      "Public Views: Partner-friendly and advocacy visuals for awareness.",
    ],
    imageUrl: "/images/elephant.jpg",
    imageAlt: "Map overlay on forest area",
  },
  {
    title: "D. Incident Reporting",
    description:
      "A centralized reporting tool that allows real-time documentation and submission of intelligence from the field.",
    points: [
      "Digital Logbook: Report crimes, conflicts, or suspicious activity securely.",
      "Multimedia Uploads: Add photos, videos, voice notes, and documents.",
      "Geo-Mapping: Auto-tagged locations on WITS maps for visual tracking.",
      "Follow-Up Feedback: Keep reporters informed (if not anonymous).",
      "Evidence Trail: Build prosecutable digital records from first contact.",
    ],
    imageUrl: "/images/reporting.jpg",
    imageAlt: "Police officer taking notes at a crime scene",
  },
];

const Features = () => {
  return (
    <div className="bg-green-50 min-h-screen text-green-900">

      <main className="max-w-7xl mx-auto px-6 py-10 space-y-16">
        {features.map((feature, index) => (
          <section
            key={index}
            className="bg-white rounded-2xl p-6 shadow-sm border border-green-200"
          >
            <div className="md:flex md:items-start">
              <img
                src={feature.imageUrl}
                alt={feature.imageAlt}
                className="w-full md:w-1/3 h-64 object-cover rounded-lg mb-4 md:mb-0 md:mr-6"
              />
              <div className="md:flex-1">
                <h2 className="text-2xl font-semibold text-green-800 mb-3">
                  {feature.title}
                </h2>
                <p className="mb-4">{feature.description}</p>
                <ul className="list-disc list-inside space-y-2">
                  {feature.points.map((point, i) => (
                    <li key={i} className="text-green-900">
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        ))}
      </main>
    </div>
  );
};

function FeaturesPage(){
    return (
        <>
        <Banner />
        <PageHeader />
        <Features />
        <Footer />
        </>
    )
}

export default FeaturesPage;
